import { Controller } from 'stimulus';
const TomSelect = require('../../lib/tom_select');

export default class extends Controller {
  connect() {
    if (this.tomSelect) return;

    this.tomSelect = new TomSelect(this.element, {
      create: true,
      createOnBlur: true,
      persist: false,
      selectOnTab: true,
    });
    this.element.classList.add('is-tom-select');
  }

  disconnect() {
    if (this.tomSelect) {
      this.element.classList.remove('is-tom-select');
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
